export {translations as EngTranslations } from './en'
export {translations as SpanishTranslations } from './es'
